<template>
  <div class="devOps_producerSpaceDemand" v-loading="loading">
    <!-- #region 表单搜索部分 -->
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px">
      <el-form-item label="项目体系" prop="systemId" :label-width="formLabelWidth">
        <el-select size="mini" :style="iptStyle" v-model="form.systemId" collapse-tags filterable
                   placeholder="请选择项目体系" clearable>
          <el-option v-for="(key, value) in allSystem.ALLSYSTEMIDS" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目名称" prop="projectName" :label-width="formLabelWidth">
        <el-input :style="iptStyle" placeholder="请输入"  @keyup.enter.native="formSearch('reset')" v-model="form.projectName" />
      </el-form-item>
      <el-form-item label="项目负责人" prop="ownerId" :label-width="formLabelWidth">
        <el-select :style="iptStyle"  multiple filterable collapse-tags size="mini" v-model="form.ownerId"  placeholder="请选择项目负责人">
          <el-option v-for="(key, value) in allUserList.DEVUSER" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select :style="iptStyle" multiple filterable collapse-tags v-model="form.status"
                   placeholder="请选择状态">
          <el-option v-for="(value, key) in allStatusList.ALLSTATUSTYPE1" :key="value" :label="value" :value="key" />
        </el-select>
      </el-form-item>
      <el-form-item label="计划开始日期" label-width="125px">
        <el-date-picker
            v-model="form.serach_plt_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期" />
      </el-form-item>
      <el-form-item label="计划完成日期" label-width="125px">
        <el-date-picker
            v-model="form.serach_complete_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期" />
      </el-form-item>
      <el-form-item label="立项日期" label-width="125px">
        <el-date-picker
            v-model="form.search_approval_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期" />
      </el-form-item>
      <div>
        <el-form-item>
          <el-button v-if="allMenuList.btn_project_query" style="margin-left:32px;font-weight: bold;font-size: 12px;" type="primary"
                     @click="formSearch('reset','search')">查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="allMenuList.btn_project_add" style="font-weight: bold;font-size: 12px;" type="primary"
                     @click="showDialogVisible('project', {})">新增项目
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="allMenuList.btn_project_export" style="font-weight: bold;font-size: 12px;" type="primary" @click="fileExport">导出
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="allMenuList.btn_project_clear" style="font-weight: bold;font-size: 12px;" type="primary"
                     @click="changeReset()">置空
          </el-button>
        </el-form-item>
      </div>
    </el-form>
    <!-- #endregion 表单搜索部分 -->

    <!-- #region 表格部分 -->
    <div style="height: 58vh;position: relative;">
      <el-table height="100%" :header-cell-style="getCellClass" row-key="id" ref="multipleTable"
                :expand-row-keys="expands" @row-click="clickRowHandle" style="margin-top:0;" :cell-style="getRowClass"
                @sort-change="sortChange" :data="tableData">
        <el-table-column  fixed="left"  prop="projectSystemName" align="center" width="120" label="项目体系" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column fixed="left"  prop="projectName" label="项目名称" min-width="160" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span @click="showDialogVisible('project', scope.row)" class="table_text_click_new" v-if="scope.row.id">
              [{{ scope.row.id }}] {{ scope.row.projectName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusDesc" align="center" width="80" label="状态" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="owner" label="项目负责人" width="120" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.owner ? scope.row.owner.nameZh : ''}} {{scope.row.owner ? '(' +scope.row.owner.nameEn + ')' : ''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="approvalDate" align="center"  sortable="custom" width="180" label="立项日期" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="planStartDate" align="center"  sortable="custom" width="180" label="计划开始日期" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="palnEndDate" align="center" sortable="custom" width="180" label="计划完成日期" :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
      <!-- #region 分页部分 -->
      <div class="block devOpsSpace_page">
        <span class="demonstration">当前页{{ currentPageLength || 0 }}条</span>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                       layout="total, prev, pager, next, sizes" :total="count">
        </el-pagination>
      </div>
      <!-- #endregion -->
    </div>
    <!-- #endregion 表格部分 -->

    <!-- #region dialog 部分 -->
    <CreateProject v-if="dialogVisible.project" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.project'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <RecordProject v-if="dialogVisible.record"   :back="back"  :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.record'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></RecordProject>
    <!-- #endregion dialog 部分 -->
    <Menu />
  </div>
</template>
<script>
import CreateProject from "@/views/tops/devOps/producerSpace/components/createProject.vue";
import RecordProject from "@/views/tops/devOps/producerSpace/components/recordProject.vue";
import {
  getDevOpsSpaceAllProjectApi,
  getDevOpsSpaceDemandListApi,
  getDevOpsSpaceReviewListApi,
  getDevOpsSpaceStageSelectmapApi, postDevOpsSpaceProjectExportApi,
} from "@/server/tops/devOps";
import { formatEnToUtf8, formatTimeToDate, formatEnToUtf8NoEn } from "@/views/tops/devOps/components/util.js";
import { getStorage, setStorage } from "@/common/utils/storage.js"
import Menu from '@/components/menu/index.vue'
import { mapState, mapMutations } from 'vuex';
import axios from "axios";
export default {
  components: {RecordProject, CreateProject, Menu },
  props: {
    tabid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 表单搜索条件
      form: {
        serach_plt_time:'',
        serach_complete_time:'',
        search_approval_time: '',
        ownerId: '',
        status: ['0','1'],
        systemId: '',
        projectName: '',
      },
      // 需求列表
      tableData: [],
      tableDataAll:[],
      // input 搜索样式
      iptStyle: {
        width: '180px'
      },
      // 弹出层部分
      dialogVisible: {
        project: false,
        record: false,
      },
      // 选中信息
      checkedInfo: {},
      cacheTableData: [],
      count: 10, // 总计
      currentPage: 1, // 当前页
      currentPageLength: 10,
      pageSize: 10, // 每页多少个
      expands: [],
      preciseSwitch: false,
      users: {},
      tableOptions: [
        {
          label: '项目体系',
          value: 'project_system'
        },
        {
          label: '需求人员',
          value: 'demander'
        },
        {
          label: '优先级',
          value: 'priority'
        },
        {
          label: '技术评审状态',
          value: 'reviewed_status'
        },
        {
          label: '方案状态',
          value: 'p_status'
        },
        {
          label: '创建时间',
          value: 'create_time'
        },
        {
          label: '期望上线时间',
          value: 'plt'
        },
        {
          label: '需求进度',
          value: 'progress'
        },
        {
          label: '系统',
          value: 'taskInfo.module'
        },
        {
          label: '开发',
          value: 'taskInfo.user_rd'
        },
        {
          label: '技术评审人',
          value: 'taskInfo.tech_reviewer'
        },
        {
          label: '测试',
          value: 'taskInfo.user_qa'
        },
        {
          label: '任务状态',
          value: 'taskInfo.status'
        },
        {
          label: '任务进度',
          value: 'taskInfo.task_progress'
        },
        {
          label: '期望发布时间',
          value: 'taskInfo.o_pdt'
        },
        {
          label: '实际发布时间',
          value: 'taskInfo.o_aelt'
        },
        {
          label: '计划开发开始日期',
          value: 'taskInfo.d_psdt'
        },
        {
          label: '计划开发完成日期',
          value: 'taskInfo.d_pedt'
        },
        {
          label: '计划测试开始日期',
          value: 'taskInfo.t_pstt'
        },
        {
          label: '计划测试完成日期',
          value: 'taskInfo.t_pett'
        },
        {
          label: '计划上线日期',
          value: 'taskInfo.d_plt'
        },
        {
          label: 'Issue',
          value: 'taskInfo.issue'
        }],
      taskStatusSorts: {
        '待开发': 1,
        '开发中': 2,
        '待测试': 3,
        '测试环境测试中': 4,
        '预发环境测试中': 5,
        'UAT测试中': 6,
        '生产环境测试中': 7,
        '待发布': 8,
        '已上线': 9
      },
      loading:false,
      tableLoading: false,
      checkedTables: ['reviewed_status','o_aelt', 'o_pdt', 'project_system', 'demander', 'priority', 'p_status', 'plt', 'progress', 'taskInfo.module', 'taskInfo.user_rd', 'taskInfo.user_qa', 'taskInfo.status', 'taskInfo.task_progress', 'taskInfo.issue'],
      is_admin:false,
    };
  },
  async created() {
    let checkedTables = getStorage('checkedTables', 'localStorage')
    let pageSize = getStorage('pageSize', 'localStorage')
    pageSize && (this.pageSize = pageSize * 1);
    this.checkedTables = checkedTables ? checkedTables.split(',') : this.checkedTables;
    this.users = this.allSelect.TEXTUSERSEN;
    await this.$store.dispatch('getDevopsSelect')
    await this.$store.dispatch('getDevopsSystem')
    //全部人员
    await this.$store.dispatch('getDevopsUserList',{userType:''})
    //项目状态
    await this.$store.dispatch('getDevopsStatusList',{type:''})
    await this.$store.dispatch('getDevopsMenuList',{})
  },
  computed: {
    ...mapState(
        {
          // 进度条
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.NEWALLSYSTEM,
          allUserList: (state) => state.devOps.NEWALLUSERLIST,
          allStatusList: (state) => state.devOps.NEWALLSTATUSLIST,
          allMenuList: (state) => state.devOps.NEWALLMENULIST,
        }
    ),
  },
  watch: {
    'tableData': {
      handler() {
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
      },
      deep: true
    }
  },
  async mounted() {
    const { proId = '',ns = '',ids = '', tabid  = '' } = this.$route.query;

    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.form = { ...this.form, user: username ? [username] : []};

    if(this.$store.state.devOps.userInfo.userId){
      let defauleOwnerId = this.$store.state.devOps.userInfo.userId;
      this.form.ownerId = [defauleOwnerId.toString()];
    }
      if (proId) {
        this.form.status = '';
        this.form.ownerId = '';
        this.form.projectName = proId;
      }
    if(ns){
      this.form.status = '';
    }
      if(ids){
        this.form.status = '';
        this.form.ownerId = '';
        this.form.projectName = ids;
      }


    this.$nextTick(async () => {
      await this.formSearch();
      //this.autoDialogDetailPop(this.tableData)
    })
    //this.form.ownerId = 3469
  },
  methods: {
    ...mapMutations(['filterSelect']),
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:20px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    // 判断任务状态是否可点击
    taskStatusDisabledFn(state) {
      return state === 'p_stop' || state === 'p_canceled'
    },
    // 点击table自选
    onSelectTableOption() {
      this.$refs.tableOption.$el.click()
    },
    onChangeTableOption(val) {
      const tableData = this.tableData;
      setStorage('checkedTables', val, 'localStorage')
      this.tableData = []
      this.$nextTick(() => {
        this.tableData = tableData;
      })
    },
    // 扩展行
    clickRowHandle(row, column, event) { },
    // 根据进度设置颜色
    colorProgressFn(g, pg) {
      if (g >= pg) return { color: 'rgb(248, 172, 89)' }
      if (pg > g >= pg - 20) return { color: '#67C23A' }
      if (pg - 20 > g) return { color: '#F56C6C' }
      return {}
    },
    // 精确开关
    preciseSwitchFn() {
      this.preciseSwitch = !this.preciseSwitch;
      this.$nextTick(() => {
        if (this.preciseSwitch) {
          this.querySelectOrgInfo()
        } else {
          this.users = this.allSelect.TEXTUSERSEN;
        }
      })
    },
    // 获取组织人员
    async querySelectOrgInfo() {
      if (!this.form.p_category.length) {
        this.users = this.allSelect.TEXTUSERSEN;
        return;
      }
      const params = {
        type: 'getusersbyorg',
        org_name: this.form.p_category.toString(),
      }
      const ret = await getDevOpsSpaceStageSelectmapApi(params);
      let orgUsers = {}
      const orgUsersArr = ret['devops-tasklist-orgusers'] || [];
      orgUsersArr.forEach((item) => {
        orgUsers[item[1]] = `${item[0]}(${item[1]})`
      })
      this.users = orgUsers
    },
    // 表单搜索
    async formSearch(type,key) {
      this.form.planStartDate='';
      this.form.palnEndDate='';
      this.form.approvalStartDate='';
      this.form.approvalEndDate='';
      this.form.planCompleteStartDate='';
      this.form.planCompleteEndDate='';
      if(this.form.serach_plt_time){
        if(this.form.serach_plt_time[0]){
          this.form.planStartDate=this.form.serach_plt_time[0];
        }
        if(this.form.serach_plt_time[1]){
          this.form.palnEndDate=this.form.serach_plt_time[1];
        }
      }
      if(this.form.serach_complete_time){
        if(this.form.serach_complete_time[0]){
          this.form.planCompleteStartDate=this.form.serach_complete_time[0];
        }
        if(this.form.serach_complete_time[1]){
          this.form.planCompleteEndDate=this.form.serach_complete_time[1];
        }
      }

      if(this.form.search_approval_time){
        if(this.form.search_approval_time[0]){
          this.form.approvalStartDate=this.form.search_approval_time[0];
        }
        if(this.form.search_approval_time[1]){
          this.form.approvalEndDate=this.form.search_approval_time[1];
        }
      }

      if(type === 'reset'){
        this.pageNo = 1;
        this.currentPage = 1;
      }
      try {
        this.$refs.multipleTable.clearSort()
        let params = {};
        for (const key in this.form) {
          const val = this.form[key];
          params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
        }
        params.pageNo = this.currentPage
        params.pageSize = this.pageSize
        this.loading = true;
        const ret = await getDevOpsSpaceAllProjectApi(params);
        this.tableData = ret.data;
        this.cacheTableData = ret.data;
        // this.currentPageLength = ret.data.length;
        this.count = ret.count;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading = false;
      }
    },
    // 判断是否需要直接弹详情
    autoDialogDetailPop(tableData) {
      const { pid = '', tid = '', sid = '' } = this.$route.query;
      if (!tableData.length) return;
      if (pid && !tid && !sid) { // 弹需求详情
        this.showDialogVisible('demand', tableData[0])
        return;
      }
      if (pid && tid && !sid) { // 弹任务详情
        this.showDialogVisible('task', tableData[0])
        return;
      }
      if (pid && tid && sid) { // 弹阶段详情
        this.showDialogVisible(this.allSelect.TEXTTASKSTATUSDIOLOGVISIBLE[tableData[0].taskInfo.status], tableData[0])
        return;
      }
      return;
    },
    // 格式化数据
    formatTableData(data) {
      let arr = []
      data.forEach(o => {
        if (o.tasks.length) {
          o.tasks.forEach((t, i) => {
            let obj = {
              sortId: `${o.id}-${i}`,
              plt:o.plt,
              taskInfo: {
                id: t.id,
                pid: o.id,
                user_qa: t.user_qa,
                user_rd: t.user_rd,
                user_uat: t.user_uat,
                tech_reviewer: t.tech_reviewer,
                module: t.module,
                status: t.status,
                task_progress: t.task_progress,
                issue: t.issue,
                domain: t.domain,
                t_pstt: t.t_pstt,
                t_pett: t.t_pett,
                d_psdt: t.d_psdt,
                o_pdt: t.o_pdt,
                o_aelt: t.o_aelt,
                d_pedt: t.d_pedt,
                d_plt: t.d_plt,
                p_status: o.p_status,
              }
            };
            if (i === 0) {
              obj = { ...obj, taskList: o.tasks, ...this.commonTableDataObj(o), create_time: o.create_time }
            }
            arr.push(obj)
          })
        } else {
          const obj = { sortId: `${o.id}-${0}`, taskInfo: {}, ...this.commonTableDataObj(o), taskList: [], create_time: o.create_time};
          arr.push(obj)
        }
      })
      return arr;
    },
    // 公共部分逻辑
    commonTableDataObj(o) {
      const { id, priority, p_status, plt, progress, plan_progress, demander, project_system, dd_plt, d_plt, reviewer, reviewed_status} = o;
      return { id, priority, p_status, plt, progress, plan_progress, demander, project_system, dd_plt, d_plt, reviewer, reviewed_status}
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    // 格式化tableData数据
    formatSortTableData() {
      let arr = []
      this.tableData.forEach(item => {
        if (item.id) {
          const ls = this.tableData.filter(itm => {
            return itm.sortId.startsWith(item.id)
          })
          arr.push(ls)
        }
      })
      return arr;
    },
    // 排序任务时间
    sortTaskTime(key, order) {
      let arr = this.formatSortTableData();
      let newArr = []
      arr.forEach(item => {
        let existDates = [], noExistDates = [];
        let maxDate = 0; // 找出最大日期
        item.forEach(t => {
          const currentDate = t.taskInfo[key];
          if (currentDate && maxDate < currentDate) {
            maxDate = currentDate
          }
          t.taskInfo[key] ? existDates.push(t) : noExistDates.push(t);
        })
        existDates.sort((a, b) => {
          return order === 'descending' ? b.taskInfo[key] - a.taskInfo[key] : a.taskInfo[key] - b.taskInfo[key];
        })
        let tArr = existDates.concat(noExistDates);
        let newTArr = []
        tArr.forEach((t, i) => {
          newTArr.push(i === 0 ? { ...t, maxDate } : t)
        })
        newArr.push(newTArr);
      })
      this.tableData = this.setTableDateHead(newArr, order)
    },
    // 排序需求列表
    setTableDateHead(arr, order) {
      let newArr = [], existDates = [], noExistDates = [];
      arr.forEach(t => {
        t[0].maxDate ? existDates.push(t) : noExistDates.push(t);
      })
      existDates.sort((a, b) => {
        return order === 'descending' ? b[0].maxDate - a[0].maxDate : a[0].maxDate - b[0].maxDate;
      })
      let pArr = existDates.concat(noExistDates);
      pArr.forEach(item => {
        let cacheIdx = 0;
        item.forEach((itm, index) => {
          if (index === 0) {
            const pi = item.filter((it, idx) => {
              if (it.id) {
                cacheIdx = idx;
                return true;
              }
            })
            itm = { ...pi[0], ...itm }
          }
          if (index === cacheIdx && cacheIdx !== 0) {
            itm = { sortId: itm.sortId, taskInfo: itm.taskInfo }
          }
          newArr.push(itm)
        })
      })
      return newArr;
    },
    // 排序事件
    async sortChange(column) {
      const { prop, order } = column;
      this.tableData = this.cacheTableData;
      if(prop === 'approvalDate') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.approvalDate) - Date.parse(a.approvalDate) : Date.parse(a.approvalDate) - Date.parse(b.approvalDate);
        })
      }
      if(prop === 'planStartDate') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.planStartDate) - Date.parse(a.planStartDate) : Date.parse(a.planStartDate) - Date.parse(b.planStartDate);
        })
      }
      if(prop === 'palnEndDate') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.palnEndDate) - Date.parse(a.palnEndDate) : Date.parse(a.palnEndDate) - Date.parse(b.palnEndDate);
        })
      }
    },
    async SearchAll() {
      try {
        let params = {};
        for (const key in this.form) {
          const val = this.form[key];
          params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
        }
        params.pageNo = 1
        params.pageSize = 9999999999999
        this.loading = true;
        const ret = await getDevOpsSpaceAllProjectApi(params);
        this.tableDataAll = ret.data;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading = false;
      }
      return false;
    },
    // 弹出模板
    async showDialogVisible(type, row,  back = '') {
      if (type === 'releaseing') {
        return;
      }
      await this.hideDialogVisible('', false)
      this.checkedInfo = row;
      this.dialogVisible[type] = true;
      this.back = back;
    },
    // 隐藏弹窗
    async hideDialogVisible(nextStep = '', search = true, ) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      if (nextStep && (typeof(nextStep) === 'string')) {
        this.$nextTick(() => {
          this.checkedInfo && (this.dialogVisible[nextStep] = true);
        })
      } else {
        search && await this.formSearch()
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      setStorage('pageSize', val, 'localStorage')
      this.formSearch();
    },
    // 分页事件
    handleCurrentChange(val) {
      this.formSearch();
    },
    changeReset(){
      this.form.status = '';
      this.form.ownerId = '';
      this.form.systemId = '';
      this.form.projectName = '';
      this.form.serach_plt_time = '';
      this.form.serach_complete_time = '';
      this.form.search_approval_time = '';
    },
    fileExport() {
      const token = getStorage('token', 'localStorage');
      let url = `https://devops-test.ehsy.com/devops/space/reporter/export?source_type=xlsx_project`;
      for (const key in this.form) {
        const val = this.form[key];
        url += `&${key}=${this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val}`;
      }
      const headers = {
        'token': token
      };
      axios.get(url, { responseType: "blob",headers: headers }).then(response => {
        let fileName = '项目导出.xlsx';
        const blob = new Blob([response.data]);
        const a = document.createElement("a");//创建a标签
        a.href = window.URL.createObjectURL(blob);// 创建下载的链接
        a.download = fileName;//下载文件名称
        a.style.display = "none";
        document.body.appendChild(a);//a标签追加元素到body内
        a.click();//模拟点击下载
        document.body.removeChild(a);// 下载完成移除元素
        window.URL.revokeObjectURL(a.href);// 释放掉blob对象
      }).catch(console.error);
      // let url = `${window.location.origin}/devops/space/reporter/new_export`;
      // for (const key in this.form) {
      //   const val = this.form[key];
      //   url += `&${key}=${this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val}`;
      // }
      // url += `&pageNo=${this.currentPage}&pageSize=${this.pageSize}`;
      // window.location.href = url;
    },
    // 将英文名字转为中卫
    formatEnToUtf8,
    formatEnToUtf8NoEn,
    // 毫秒值转 YYYY-MM-DD HH:mm:ss
    formatTimeToDate
  },
};
</script>
<style lang="scss">
.devOps_producerSpaceDemand {

  .link_svg {
    position: absolute;
    left: -96px;
    top: 2px;
    transform: rotate(90deg);
    cursor: pointer;
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .dialog-footer .el-button {
    font-weight: bold;
    margin-left: 0;
    margin-right: 10px;
  }

  .form_warp .el-form-item {
    margin-bottom: 6px;
  }

  padding-top: 10px;

  // #region select
  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .el-input__inner {
    margin-left: -5px;
  }

  // #endregion select
  .priority_style {
    border-radius: 5px;
    text-align: center;
    width: fit-content;
    padding: 0 5px;
    margin: auto;
  }

  .el-dialog__header {
    font-weight: bold;
  }

  .el-form-item__label {
    font-weight: bold;
  }

  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
}

/* #region 滚动条部分 */
.el-table__body-wrapper {
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.el-table__body-wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.tips-message {
  max-height: 480px;
  overflow-y: auto;
  white-space: pre-wrap;
  background: #f1fbec;
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.websocket_style {
  background-color: #333;
  color: #fefefe;
  padding: 8px;

  a {
    color: #e6a23c;
  }
}

.tips-message::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.tips-message::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.tips-message::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

/* #endregion 滚动条部分 */

.table_options_warp {
  position: absolute;
  z-index: 4;
  left: 20px;
  top: 22px;
  width: 20px;
  cursor: pointer;
}
.devOps_producerSpaceDemand .el-form-item__label {
  font-weight: bold;
  font-size: 12px;
}
</style>
